(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    if (!window.fetch || !window.DOMParser) return;

    function headerOffset() {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return parseInt(v, 10) || 0;
    }

    function enhance(root) {
      if (root.dataset.peBound) return;
      root.dataset.peBound = '1';
      var sectionId = root.dataset.sectionId;
      if (!sectionId) return;

      function bindSort() {
        var form = root.querySelector('[data-sort-form]');
        if (!form) return;
        var submit = form.querySelector('[data-sort-submit]');
        if (submit) submit.hidden = true;
        var select = form.querySelector('[data-sort-select]');
        if (select && !select.dataset.peBound) {
          select.dataset.peBound = '1';
          select.addEventListener('change', function () {
            var action = form.getAttribute('action') || window.location.pathname;
            var params = new URLSearchParams(new FormData(form));
            render(action + '?' + params.toString(), true);
          });
        }
      }

      function render(url, push) {
        var content = root.querySelector('[data-collection-content]');
        if (content) content.setAttribute('aria-busy', 'true');
        var join = url.indexOf('?') === -1 ? '?' : '&';
        fetch(url + join + 'section_id=' + encodeURIComponent(sectionId))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collection-content]');
            if (fresh && content) {
              content.innerHTML = fresh.innerHTML;
              bindSort();
            }
            if (content) content.removeAttribute('aria-busy');
            if (push) history.pushState({ suCollection: true }, '', url);
            var top = root.getBoundingClientRect().top + window.scrollY - headerOffset();
            window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
          })
          .catch(function () { window.location.href = url; });
      }

      root.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var link = e.target.closest('[data-filter-link], [data-pagination] a');
        if (!link || !link.getAttribute('href')) return;
        e.preventDefault();
        render(link.getAttribute('href'), true);
      });

      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.suCollection) render(window.location.href, false);
      });

      bindSort();
    }

    function init() {
      document.querySelectorAll('[data-collection]').forEach(enhance);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initGallery(root) {
      var gallery = root.querySelector('[data-pdp-gallery]');
      if (!gallery) return;
      var slides = Array.prototype.slice.call(gallery.children);
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
      if (dots.length < 2 || !('IntersectionObserver' in window)) return;
      function setActive(i) {
        for (var d = 0; d < dots.length; d++) {
          dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
        }
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var i = slides.indexOf(e.target);
              if (i > -1) setActive(i);
            }
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach(function (s) {
        io.observe(s);
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-pdp-dot'), 10);
          if (!slides[i]) return;
          var reduce = document.documentElement.dataset.reducedMotion === 'true';
          slides[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      // Prev/next arrows scroll one slide (slides are full container width).
      var reduce = function () {
        return document.documentElement.dataset.reducedMotion === 'true';
      };
      function go(dir) {
        gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
      }
      var prevBtn = root.querySelector('[data-pdp-prev]');
      var nextBtn = root.querySelector('[data-pdp-next]');
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          go(-1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          go(1);
        });

      // Mouse drag-to-scroll (touch uses native scrolling). Pointer capture keeps events
      // flowing if the cursor leaves; snap is disabled mid-drag and restored on release.
      var isDown = false,
        startX = 0,
        startScroll = 0,
        moved = false,
        pid = null;
      gallery.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = gallery.scrollLeft;
        pid = e.pointerId;
        gallery.style.scrollSnapType = 'none';
        try {
          gallery.setPointerCapture(pid);
        } catch (err) {}
      });
      gallery.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        gallery.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!isDown) return;
        isDown = false;
        gallery.style.scrollSnapType = '';
        if (pid !== null) {
          try {
            gallery.releasePointerCapture(pid);
          } catch (err) {}
          pid = null;
        }
      }
      gallery.addEventListener('pointerup', endDrag);
      gallery.addEventListener('pointercancel', endDrag);
      gallery.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
          }
        },
        true
      );
      gallery.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }
    function init() {
      document.querySelectorAll('[data-pdp]').forEach(function (root) {
        initGallery(root);
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    if (!window.fetch || !window.DOMParser) return;
    function initPredictive() {
      document.querySelectorAll('[data-predictive-search-form]').forEach(function (form) {
        if (form.dataset.psBound) return;
        form.dataset.psBound = '1';
        var input = form.querySelector('[data-predictive-search-input]');
        var panel = form.querySelector('[data-predictive-search-results]');
        var endpoint = form.dataset.predictiveUrl;
        if (!input || !panel || !endpoint) return;
        var timer;
        function hide() { panel.classList.add('hidden'); panel.innerHTML = ''; }
        input.addEventListener('input', function () {
          clearTimeout(timer);
          var q = input.value.trim();
          if (q.length < 2) { hide(); return; }
          timer = setTimeout(function () {
            fetch(endpoint + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=6')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-search]');
                panel.innerHTML = fresh ? fresh.outerHTML : html;
                panel.classList.remove('hidden');
              })
              .catch(function () { hide(); });
          }, 200);
        });
        input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
        document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
      });
    }
    if (document.readyState !== 'loading') initPredictive();
    else document.addEventListener('DOMContentLoaded', initPredictive);
    document.addEventListener('shopify:section:load', initPredictive);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-product"]) return;
  try {
    
  (function () {
    function initGallery(root) {
      var gallery = root.querySelector('[data-pdp-gallery]');
      if (!gallery) return;
      var slides = Array.prototype.slice.call(gallery.children);
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
      if (dots.length < 2 || !('IntersectionObserver' in window)) return;
      function setActive(i) {
        for (var d = 0; d < dots.length; d++) {
          dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
        }
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var i = slides.indexOf(e.target);
              if (i > -1) setActive(i);
            }
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach(function (s) {
        io.observe(s);
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-pdp-dot'), 10);
          if (!slides[i]) return;
          var reduce = document.documentElement.dataset.reducedMotion === 'true';
          slides[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      // Prev/next arrows scroll one slide (slides are full container width).
      var reduce = function () {
        return document.documentElement.dataset.reducedMotion === 'true';
      };
      function go(dir) {
        gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
      }
      var prevBtn = root.querySelector('[data-pdp-prev]');
      var nextBtn = root.querySelector('[data-pdp-next]');
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          go(-1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          go(1);
        });

      // Mouse drag-to-scroll (touch uses native scrolling). Pointer capture keeps events
      // flowing if the cursor leaves; snap is disabled mid-drag and restored on release.
      var isDown = false,
        startX = 0,
        startScroll = 0,
        moved = false,
        pid = null;
      gallery.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = gallery.scrollLeft;
        pid = e.pointerId;
        gallery.style.scrollSnapType = 'none';
        try {
          gallery.setPointerCapture(pid);
        } catch (err) {}
      });
      gallery.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        gallery.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!isDown) return;
        isDown = false;
        gallery.style.scrollSnapType = '';
        if (pid !== null) {
          try {
            gallery.releasePointerCapture(pid);
          } catch (err) {}
          pid = null;
        }
      }
      gallery.addEventListener('pointerup', endDrag);
      gallery.addEventListener('pointercancel', endDrag);
      gallery.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
          }
        },
        true
      );
      gallery.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }
    function init() {
      document.querySelectorAll('[data-pdp]').forEach(function (root) {
        initGallery(root);
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-splash"]) return;
  try {
    
(function () {
  var modal = document.getElementById('password-modal');
  if (!modal) return;
  function openModal() {
    if (typeof modal.showModal === 'function') { modal.showModal(); }
    else { modal.setAttribute('open', ''); }
  }
  document.querySelectorAll('[data-password-open]').forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });
  modal.querySelectorAll('[data-password-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { modal.close(); });
  });
  if (modal.querySelector('[data-password-error]')) { openModal(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    function load(el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
          if (fresh) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }
    function init() {
      document.querySelectorAll('[data-recommendations]').forEach(function (el) {
        if (!el.dataset.url) return;
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0] && entries[0].isIntersecting) { io.disconnect(); load(el); }
          }, { rootMargin: '200px' });
          io.observe(el);
        } else {
          load(el);
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
